module.exports = __webpack_public_path__ + "img/choose_list_3.0af615d6.png";